module.exports = __webpack_public_path__ + "assets/img/7_343_big.d949387f.jpg";